// extracted by mini-css-extract-plugin
export default {"root":"CustomEmojiEffect-module__root","particle":"CustomEmojiEffect-module__particle"};